export function onBrowser() {
  return typeof window === "object";
}
